import { IAdminTokensRequestsState } from 'types/store/admin/tokensRequests';

export const initState: IAdminTokensRequestsState = {
  tokensRequestsList: null,
  isTokensRequestsLoading: false,
  tokensRequest: null,
  issueTokensRequest: null,
};
